export default "__VITE_ASSET__BM9uW6bV__"